// export const userApi = "http://localhost:8080";
export const userApi = "https://api.kidscur.com/user";
// export const dmsApi = "http://localhost:8082/dms/api/v1";
export const dmsApi = "https://api.kidscur.com/dms/api/v1";
export const largeUploadApi = "https://api.kidscur.com/dms/large-upload";
// export const placesApi = "http://localhost:8081/places";
export const placesApi = "https://api.kidscur.com/places";
